import { createContext } from 'react';
import { ScheduleRange } from 'store/scheduleRanges/interfaces';
import { ScheduleWorkingHours } from '../interfaces';

export interface ScheduleCalendarContextProps {
  scheduleRanges: ScheduleRange[];
  setCurrentDate: React.Dispatch<React.SetStateAction<Date>>;
  currentDate: Date;
  draftScheduleWorkingHours: ScheduleWorkingHours | null;
  handleAddDraftScheduleWorkingHours: (
    scheduleData: ScheduleWorkingHours,
  ) => void;
  isDraftCreating: boolean;
  setIsDraftCreating: React.Dispatch<React.SetStateAction<boolean>>;
  updateEndDateOfDraftScheduleWorkingHours: (
    date: Date,
    ignoreLimit?: boolean,
  ) => void;
  updateStartDateOfDraftScheduleWorkingHours: (date: Date) => void;
  handleOnCloseDraftForm: () => void;
  draftAnchorEl: HTMLDivElement | null;
  setDraftAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
}

export const ScheduleCalendarContext = createContext<
  ScheduleCalendarContextProps | undefined
>(undefined);
